import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const UnbilledItemsViewChunk = React.lazy(() =>
  import('../feature-sets/UnbilledItemsView').then(({ UnbilledItemsView }) => ({
    default: UnbilledItemsView,
  }))
)

export const UnbilledItemsPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.unbilledItemsTabName)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.unbilledItemsPageTitle),
        },
      ]}
    >
      <UnbilledItemsViewChunk />
    </Page>
  )
}
